import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CloseAssetModalLocations } from '../types';

export type TrackAssetModalClosed = {
  location: CloseAssetModalLocations;
};

export const useTrackAssetModalClosed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalClosed = useCallback(
    (params: TrackAssetModalClosed) => {
      track('Closed asset details modal', params);
    },
    [track],
  );

  return { trackAssetModalClosed };
};
